<mat-toolbar matDialogTitle class="mat-accent m-0">
    <mat-toolbar-row fxLayout="row" class="px-15" fxLayoutAlign="space-between center">
        <span class="title dialog-title">Dettagli {{ dettagliAccontiVersati.cellId | removeSpecialChars }} </span>
        <button mat-icon-button mat-dialog-close (click)="dialogRef.close()" aria-label="Close dialog">
            <mat-icon>close</mat-icon>
        </button>
    </mat-toolbar-row>
</mat-toolbar>

<div class="cssWidgetWrapper">
    <contributi-pagati-tramite-F24
        [dataToSendDichiarazione]="dettagliAccontiVersati.dataToSendDichiarazione"
        [categorieTributi]="{ primaCategoria: 15, secondaCategoria: 16 }"></contributi-pagati-tramite-F24>
</div>
